export {default} from './EditNotes.connect';
